// @ts-nocheck
import moment from 'moment'

export const DAY_MONTH_DATE = "DD MMM";
export const FULL_DATE_DATA_ARRAY = "MMM DD, YYYY HH:mm";

export enum OBJECT_CURRENCY {
  eur = "€",
  usd = "$",
}

export default class FormatText {
  static isNumber(n) {
    return !Number.isNaN(parseFloat(n)) && Number.isFinite(n)
  }

  static formatNumber(data: any) {
    const { languages } = window.navigator

    if (!FormatText.isNumber(data)) return 0
    return new Intl.NumberFormat(languages[0]).format(data)
  }

  /**
   * @static
   * @param {*} data
   * @param {string} [currency='EUR']
   * @returns
   * @memberof FormatText
   */
  static formatNumberWithCurrency(data: any, currency = 'EUR') {
    const number = FormatText.formatNumber(data)

    const currencyString = (currency as any) instanceof String ? OBJECT_CURRENCY[currency?.toLowerCase()] : '€'

    return `${number} ${currencyString}`
  }

  /**
   * formatDateCharts
   * @param data
   * @return {*}
   */
  static formatDateCharts(data: any) {
    if (!FormatText.isNumber(data)) return 0
    if (data.toString().length < 10 || +data.toString().length > 10) return 0
    return moment.unix(data).format(DAY_MONTH_DATE) || ''
  }

  /**
   * @static
   * @param {*} percentage
   * @returns
   * @memberof FormatText
   */
  static formatNumberTotalReports(percentage: number) {
    const number = FormatText.formatNumber(percentage)
    if (Number.isInteger(percentage)) return FormatText.formatNumber(percentage)

    return `${number}%`
  }

  static formatPercentage(percentage: number) {
    const number = FormatText.formatNumber(percentage)

    return `${number}%`
  }

  /**
   * @static
   * @param {number} [x=0]
   * @returns
   * @memberof FormatText
   */
  static numberSeparator(x = 0) {
    if (!FormatText.isNumber(x)) return '0'
    const res = x.toFixed(0)
    return res.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  /**
   * formatThousand
   * @param label
   */
  static formatMillionsTrending(label: number) {
    if (!FormatText.isNumber(label)) return ''
    return label > 999999 ? `${FormatText.numberSeparator(label)}k` : label.toFixed(0)
  }

  /**
   * @static
   * @param {*} label
   * @returns
   * @memberof FormatText
   */
  static formatThousandTrending(label: number) {
    if (!FormatText.isNumber(label)) return ''
    return label > 999 ? `${FormatText.numberSeparator(label)}` : label.toFixed(0)
  }

  /**
   * @static
   * @param {*} label
   * @returns
   * @memberof FormatText
   */
  static formatThousand(label: number) {
    if (!FormatText.isNumber(label)) return ''
    return label > 999 ? `${FormatText.numberSeparator(label)}k` : label.toFixed(0)
  }

  /**
   * @static
   * @param {string} [str='']
   * @param {string} [expectedCharToSplit='']
   * @param {string} [expectedCharToJoin='']
   * @returns
   * @memberof FormatText
   */
  static splitCharAndJoin(str = '', expectedCharToSplit = '', expectedCharToJoin = '') {
    if (typeof str !== 'string' || typeof expectedCharToJoin !== 'string' || typeof expectedCharToJoin !== 'string') {
      return ''
    }
    const reformatStr = str.split(expectedCharToSplit).join(expectedCharToJoin)
    return reformatStr
  }

  /**
   * @static
   * @param {*} date
   * @returns
   * @memberof FormatText
   */
  static formatDateDataArray(date: any) {
    if (date.toString().length < 10) return '0'
    if (!FormatText.isNumber(date)) return '0'

    const dateFormat = moment.unix(date).format(FULL_DATE_DATA_ARRAY)
    const split = dateFormat.split(' ')

    split[3] = split[3].split(':').join('h')
    split[2] = `${split[2]} at`

    return split.join(' ')
  }

  /**
   *
   *
   * @static
   * @param {*} svg
   * @returns
   * @memberof FormatText
   */
  static formatSVGBase64(svg: string) {
    if (typeof svg !== 'string') return ''
    return svg.split('"')[1]
  }

  /**
   * @static
   * @param {number} [imp=0]
   * @param {number} [cpm=0]
   * @returns
   * @memberof FormatText
   */
  static calculBudgetForCPM(imp = 0, cpm = 0) {
    if (!FormatText.isNumber(imp) || !FormatText.isNumber(cpm)) return 0
    return (imp / 1000) * cpm
  }

  /**
   * @static
   * @param {number} [click=0]
   * @param {number} [cpc=0]
   * @returns
   * @memberof FormatText
   */
  static calculBudgetForCPC(click = 0, cpc = 0) {
    if (!FormatText.isNumber(click) || !FormatText.isNumber(cpc)) return 0
    return click * cpc
  }

  /**
   * @static
   * @returns
   * @memberof FormatText
   */
  static getIntervalIntoYears(start = 2018): number[] {
    const currentYear = +moment().format('YYYY')
    let years: number[] = []

    for (let i = start; i <= currentYear; i += 1) {
      years = [...years, i]
    }

    return years
  }

  /**
  * @static
  * @returns
  * @memberof formatCPM
  */

  static formatCPM(cost_per: number, goal_type_id: number): string {
    let price = cost_per

    if (goal_type_id === 1) {
      price = cost_per * 1000
    }

    return this.formatNumberWithCurrency(price)
  }
}
